import React from "react";
import AppModal from "../common/AppModal";
import { Alert } from "@mui/material";
import CreateOrUpdateProductForm from "../../forms/CreateOrUpdateProductForm";

const UpdateProductModal = ({ open, onClose, product, loading, error }) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Update Product Details"
    width="sm"
  >
    {error && (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    )}
    <CreateOrUpdateProductForm product={product} isEditing loading={loading} />
  </AppModal>
);

export default UpdateProductModal;
